import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
export default new VueI18n({
  locale: localStorage.locale ? localStorage.locale : 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      ...require('../translations/en.json'),
      validation: require('../translations/validations.en.json')
    },
    ar: {
      ...require('../translations/ar.json'),
      validation: require('../translations/validations.ar.json')
    }
  }
})
